import { CircularProgress, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { action, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { HotKeys } from 'react-hotkeys';
import '../../css/cabecalho.css';
import ReactComponent from '../ReactComponent';
import DialogComplementoAnotacao from './DialogComplementoAnotacao';
import FiltrosAtivos from './FiltrosAtivos';
import PainelProcessosDetalhes from './PainelProcessosDetalhes';
import ToolbarSalaSessao from './ToolbarSalaSessao';

class SalaSessao extends ReactComponent {
    cursor = 'pointer';

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            habilitarAtualizacaoInformacoesProcesso: action,
            up: action,
            down: action,
            right: action,
            left: action,
            pageUp: action,
            pageDown: action,
            home: action,
            end: action,
            selecionarAbaDireita: action,
            selecionarAbaEsquerda: action,
            toggleProcessDetailsPanel: action
        });

        props.stores.routerStore.storeRotaAtual = 'salaSessaoStore';
    }

    componentDidMount() {
        this.sessaoStore.inicializarSessaoJulgamento();
        this.habilitarAtualizacaoInformacoesProcesso();
    }

    habilitarAtualizacaoInformacoesProcesso() {
        this.sessaoStore.atualizacaoInformacoesProcessoHabilitada = true;
    }

    searchFocus() {
        const element = document.getElementById('numero');

        if (element !== null) {
            element.focus();
        }
    }

    up = () => {
        if (this.salaSessaoStore.modalCertidaoAberto) {
            this.salaSessaoStore.exibirProcessosComCertidao = true;
        }
        this.salaSessaoStore.expandirProcessoAnterior();
    };

    down = () => {
        if (this.salaSessaoStore.modalCertidaoAberto) {
            this.salaSessaoStore.exibirProcessosComCertidao = true;
        }
        this.store.expandirProximoProcesso();
    };

    right = () => {
        this.selecionarAbaDireita();
    };

    left = () => {
        this.selecionarAbaEsquerda();
    };

    pageUp = () => {
        this.salaSessaoStore.exibirProcessoPeloIndice(this.salaSessaoStore.indiceProcessoExpandido - 7);
    };

    pageDown = () => {
        this.salaSessaoStore.exibirProcessoPeloIndice(this.salaSessaoStore.indiceProcessoExpandido + 7);
    };

    home = () => {
        this.salaSessaoStore.exibirProcessoPeloIndice(0);
    };

    end = () => {
        this.setTimeout(() => {
            this.salaSessaoStore.exibirProcessoPeloIndice(this.salaSessaoStore.processosEmExibicao.length - 1);
        });
    };

    selecionarAbaDireita() {
        this.salaSessaoStore.alterarProcessosEmExibicao('A');
    }

    selecionarAbaEsquerda() {
        this.salaSessaoStore.alterarProcessosEmExibicao('P');
    }

    toggleProcessDetailsPanel = () => {
        this.appStore.toggleMostrarPainelProcessosDetalhes();
    };

    render() {
        const handlers = {
            moveUp: this.up,
            moveDown: this.down,
            moveRight: this.right,
            moveLeft: this.left,
            search: this.searchFocus,
            home: this.home,
            end: this.end,
            pageUp: this.pageUp,
            pageDown: this.pageDown,
            toggleProcessDetailsPanel: this.toggleProcessDetailsPanel
        };
        const keyMap = {
            moveUp: 'ctrl+up',
            moveDown: 'ctrl+down',
            moveRight: 'ctrl+right',
            moveLeft: 'ctrl+left',
            search: 'ctrl+shift+f',
            home: 'ctrl+alt+home',
            end: 'ctrl+alt+end',
            pageUp: 'ctrl+alt+pageup',
            pageDown: 'ctrl+alt+pagedown',
            toggleProcessDetailsPanel: 'ctrl+\\'
        };
        return this.sessaoStore.carregandoSessao ||
            (this.sessaoStore.idSessaoSelecionada && !this.sessaoStore.sessaoSelecionada) ? (
            <div style={{ display: 'flex' }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    color={grey[500]}
                    variant="h6"
                    sx={{ margin: '25px 10px', fontStyle: 'italic' }}
                >
                    Carregando sessão de julgamento...
                </Typography>
            </div>
        ) : (
            <HotKeys
                handlers={handlers}
                keyMap={keyMap}
                style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
            >
                <ToolbarSalaSessao />
                <div
                    style={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}
                    id="no-print"
                    tabIndex="-1"
                >
                    <FiltrosAtivos />
                    <PainelProcessosDetalhes />
                </div>
                <DialogComplementoAnotacao />
            </HotKeys>
        );
    }
}

export default inject('stores')(observer(SalaSessao));
